export class WizardTrackers {
  static readonly WIZARD_SELECT_STEP_CLICK = '[Wizard] select step click';

  static readonly WIZARD_FOOTER_BACK_CLICK = '[Wizard] footer back click';

  static readonly WIZARD_FOOTER_CANCEL_CLICK = '[Wizard] footer cancel click';
}
